import { getScriptDataAttribute } from "../utils/getScriptDataAttribute";
import { pluginConfig } from "@/globals/pluginConfig";
import { LANGUAGES } from "./Languages";

export function getDefaultLanguage() {
    const detectedLanguage = 
        getScriptDataAttribute("lang") ||
        document.documentElement?.lang ||
        navigator?.language ||
        document.querySelector('meta[http-equiv="Content-Language"]')?.content;

    const languageCode = detectedLanguage?.split(/[-_]/)?.[0]?.trim() || pluginConfig.language.default;
    
    // Check if the detected language is in the LANGUAGES list
    const isLanguageSupported = LANGUAGES.some(lang => lang.code === languageCode);
    
    // If the detected language is in the LANGUAGES list, use it
    // Otherwise, use the default language from pluginConfig
    if (isLanguageSupported) {
        return languageCode;
    } else {
        return pluginConfig.language.default;
    }
}